export const ga = {
  trackingId: process.env.REACT_APP_GOOGLE_ANALYTICS_ID,
  options: {
    debug: process.env.NODE_ENV === 'development'
  }
};